import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'map', component: () => import('../views/MapPage.vue') },
    { path: '/journeys', name: 'journey-planner', component: () => import('../views/JourneyPlannerPage.vue') },
    { path: '/vehicles', name: 'active-vehicles', component: () => import('../views/ActiveVehiclesPage.vue') },
    { path: '/statistics', name: 'network-statistics', component: () => import('../views/NetworkStatisticsPage.vue') },
    {
      path: '/statistics/routes',
      name: 'network-route-statistics',
      component: () => import('../views/NetworkRouteStatisticsPage.vue'),
    },
    {
      path: '/statistics/about',
      name: 'network-statistics-guide',
      component: () => import('../views/NetworkStatisticsGuidePage.vue'),
    },
    { path: '/vehicles/:vehicleIdentityId', name: 'vehicle-history', component: () => import('../views/VehicleHistoryPage.vue') },
  ],
})
